import { render, staticRenderFns } from "./intervenciones.vue?vue&type=template&id=5a3c4611&scoped=true&"
import script from "./intervenciones.vue?vue&type=script&lang=js&"
export * from "./intervenciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c4611",
  null
  
)

export default component.exports